var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9053 28.4784L2.31738 55.5587C0.860742 54.4331 0 52.6895 0 50.8577V6.16533C0 4.31143 0.838672 2.56787 2.31738 1.46436L29.9053 28.4784Z",
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7991 28.4786C51.7991 30.6194 50.6515 32.6058 48.7755 33.6651L40.1019 38.4765L29.8833 28.5007L40.1019 18.5249L48.7755 23.3804C50.6515 24.3956 51.7991 26.3599 51.7991 28.4786Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1238 38.4763L8.67363 56.0442C7.81289 56.5077 6.8418 56.7505 5.84863 56.7505C4.81133 56.7726 3.79609 56.4856 2.93535 55.956C2.71465 55.8456 2.51602 55.7132 2.31738 55.5808L29.9053 28.5005L40.1238 38.4763Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1238 18.5026L29.9053 28.4784L2.31738 1.44225C2.51602 1.30982 2.71465 1.1774 2.93535 1.06705C4.70097 0.00767626 6.88593 -0.036463 8.67363 0.978771L40.1238 18.5026Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.e303ba8d0ee9a33429d506b536f02335.svg";
export { ForwardRef as ReactComponent };